/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The TrustCommerceoneTimePaymentsOneTimePayment model module.
 * @module model/TrustCommerceoneTimePaymentsOneTimePayment
 * @version v0.3
 */
export default class TrustCommerceoneTimePaymentsOneTimePayment {
  /**
   * Constructs a new <code>TrustCommerceoneTimePaymentsOneTimePayment</code>.
   * @alias module:model/TrustCommerceoneTimePaymentsOneTimePayment
   * @class
   * @param orderId {String} ID of the order this one-time payment is for
   * @param billingId {String} The ID of the billing that will be charged
   */
  constructor(orderId, billingId) {
    this.orderId = orderId;
    this.billingId = billingId;
  }

  /**
   * Constructs a <code>TrustCommerceoneTimePaymentsOneTimePayment</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TrustCommerceoneTimePaymentsOneTimePayment} obj Optional instance to populate.
   * @return {module:model/TrustCommerceoneTimePaymentsOneTimePayment} The populated <code>TrustCommerceoneTimePaymentsOneTimePayment</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TrustCommerceoneTimePaymentsOneTimePayment();
      if (data.hasOwnProperty('order_id'))
        obj.orderId = ApiClient.convertToType(data['order_id'], 'String');
      if (data.hasOwnProperty('billing_id'))
        obj.billingId = ApiClient.convertToType(data['billing_id'], 'String');
    }
    return obj;
  }
}

/**
 * ID of the order this one-time payment is for
 * @member {String} orderId
 */
TrustCommerceoneTimePaymentsOneTimePayment.prototype.orderId = undefined;

/**
 * The ID of the billing that will be charged
 * @member {String} billingId
 */
TrustCommerceoneTimePaymentsOneTimePayment.prototype.billingId = undefined;

